module.exports = vuedraggable;